<template>
  <div class="download-container" v-if="isOpen">
    <div class="flex">
      <div class="logo">
        <svg xmlns="http://www.w3.org/2000/svg" width="75" height="110" fill="none" viewBox="0 0 75 110">
          <path
            fill="#fff"
            d="M37.616 0c.512.64.932 1.348 1.248 2.104.986 1.581 1.897 3.225 2.893 4.831 2.614 4.216 5.12 8.567 7.715 12.79.707 1.153 1.267 2.325 1.986 3.46C55.51 29.639 59.17 36.352 63.2 42.853c3.834 6.185 7.654 12.124 10.155 19.667.632 1.914.812 3.995 1.303 6.082.165.727.07 1.52.227 2.218v1.089c.17 1.208.151 2.436-.056 3.638-.204.91-.016 1.752-.227 2.615-.4 1.639-.644 3.357-1.134 4.831-3.285 10.624-11.033 19.281-21.216 23.704-2.816 1.143-5.718 2.055-8.68 2.728-.794.206-1.552.097-2.382.285-.695.116-1.396.192-2.1.228h-1.479c-1.116.111-2.241.073-3.347-.114-.866-.195-1.716-.028-2.553-.227-1.792-.427-3.608-.659-5.218-1.195-.483-.165-.88-.179-1.361-.341-1.677-.554-3.308-1.238-4.88-2.046-.379-.197-.768-.29-1.133-.512-1.684-1.025-3.33-2.033-4.88-3.183-.628-.466-1.182-1.056-1.808-1.535l-.68-.74c-1.304-1.085-2.45-2.349-3.403-3.752-.518-.699-1.141-1.384-1.644-2.104-2.197-3.201-3.917-6.706-5.106-10.403-.632-1.904-.812-3.967-1.304-6.082-.199-.852.017-1.848-.164-2.728-.173-1.036-.173-2.094 0-3.13l.113-2.331c.304-1.33.347-2.8.68-4.036.165-.621.147-1.166.341-1.763.718-2.21 1.274-4.4 2.155-6.425 2.664-6.066 6.992-11.25 12.48-14.95 1.919-1.265 3.908-2.42 5.957-3.459.708-.482 1.47-.883 2.268-1.194.405.866.9 1.685 1.48 2.445.855 1.354 1.606 2.756 2.438 4.093 2.719 4.367 5.119 8.871 7.828 13.245.75 1.208 1.452 2.471 2.213 3.695.464.59.846 1.24 1.134 1.932h-.056c-.52-.12-1.06-.14-1.588-.057-1.306.062-2.593.35-3.8.853-3.003 1.19-5.23 3.783-5.958 6.935-.45 1.695-.45 3.478 0 5.173.855 2.917 3.015 5.27 5.844 6.367.668.218 1.35.39 2.042.513.803.16 1.63.18 2.44.055.831-.186 1.49-.105 2.212-.34 1.48-.523 2.86-1.291 4.084-2.274.506-.334.964-.735 1.36-1.194.798-1.022 1.41-2.176 1.809-3.41.385-1.71.328-3.49-.164-5.173-.201-.846-.448-1.68-.739-2.5-.937-2.074-2.037-4.07-3.287-5.969-.822-1.334-1.498-2.7-2.326-4.036-2.94-4.74-5.736-9.647-8.679-14.381-1.203-1.936-2.206-3.921-3.404-5.855-1.644-2.65-3.167-5.397-4.822-8.072-.598-.967-1.15-1.96-1.759-2.955-.17-.195-.321-.404-.454-.626.22-.591.526-1.147.908-1.648.955-1.68 1.987-3.327 3.007-4.942 2.67-4.232 5.045-8.576 7.659-12.85.986-1.605 1.931-3.267 2.949-4.888.357-.593.797-1.18 1.12-1.824z"
          />
        </svg>
      </div>

      <h1>Töltsd le<br />az appot!</h1>
    </div>

    <div class="flex">
      <a href="https://apps.apple.com/hu/app/doxocial/id1541389635" target="_blank" v-if="isIos">
        <img :src="require('@/assets/images/os/appstore-badge.svg')" class="badge" @click="goToDownload" />
      </a>

      <a href="https://play.google.com/store/apps/details?id=org.doxocial.application" target="_blank" v-else>
        <img :src="require('@/assets/images/os/google-play-badge.svg')" class="badge" @click="goToDownload" />
      </a>

      <img
        :src="require('@/assets/images/icons/close-black.svg')"
        alt="close"
        class="btn-close"
        @click.prevent="goToDownload"
      />
    </div>
  </div>
</template>

<script>
import { defineComponent, ref } from 'vue'
import { isPlatform } from '@ionic/vue'

export default defineComponent({
  name: 'DownloadApp',
  setup() {
    const isIos = ref(isPlatform('ios'))
    const isOpen = ref(true)

    const setCookie = () => {
      isOpen.value = false
    }

    const goToDownload = () => {
      setCookie()
    }

    return {
      isIos,
      isOpen,
      goToDownload,
    }
  },
})
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@900&display=swap');

.download-container {
  height: 68px;
  background: white;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15);
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 18px;

  .flex {
    display: flex;
    align-items: center;
  }

  .logo {
    width: 45px;
    height: 45px;
    min-width: 45px;
    border-radius: 10px;
    background: #ff2870;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0;
    margin-right: 10px;

    svg {
      width: 22.54px;
    }
  }

  h1 {
    font-family: 'Poppins', sans-serif !important;
    font-weight: 900;
    font-size: 16px !important;
    letter-spacing: -0.5px !important;
    line-height: 14px;
    padding: 0 !important;
    margin: 0 !important;
    margin-right: 17px !important;
  }

  a {
    margin-right: 18px;
    height: 45px;
  }

  .badge {
    max-height: 45px;
    height: 100%;
  }

  .btn-close {
    height: 12px;
  }
}
</style>
